<template>

        <v-select
                
                
                prepend-icon="ink_marker"
                :items="items"
                v-model="item"
                :label="$t('delivery.coupon.labels.discountType')"
                :loading="loading"
                :error="hasInputErrors('discountType')"
                :error-messages="getInputErrors('discountType')"
                color="secondary"
                item-color="secondary"
                :rules="required"
                :clearable="clearable"
                :multiple="multiple"
                :chips="chips"
                :solo="solo"
        ></v-select>

</template>

<script>

    import {InputErrorsByProps, RequiredRule} from '@dracul/common-frontend'
    
    

    export default {
        name: "DiscountTypeCombobox",
        mixins: [InputErrorsByProps, RequiredRule],
        props:{
            value: {type: [String, Array]},
            clearable: {type:Boolean, default: false},
            multiple: {type:Boolean, default: false},
            solo: {type:Boolean, default: false},
            chips: {type:Boolean, default: false}
        },
        data() {
            return {
                items: ['PORCENTAJE','MONTO_FIJO'],
                loading: false
            }
        },
        computed: {
           item: {
                get() { return this.value },
                set(val) {this.$emit('input', val)}
            }
        },
        methods: {
            validate(){
              return this.$refs.form.validate()
            }
        }
    }
</script>

<style scoped>

</style>

